import { Modal } from './UI'
import { Badge, MarketBadge, LinkCell, HtmlCell } from './UI'

function Row({ label, value, isLink, isBadge, isMarket }) {
  if (!value && value !== 0) return null
  return (
    <div style={{display:'flex',gap:12,padding:'9px 0',borderBottom:'1px solid var(--border)',alignItems:'flex-start'}}>
      <div style={{width:170,flexShrink:0,fontSize:10,fontWeight:600,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.7px',paddingTop:3,fontFamily:'DM Mono,monospace'}}>{label}</div>
      <div style={{flex:1,fontSize:13,color:'var(--text)',wordBreak:'break-word',lineHeight:1.5}}>
        {isLink ? <LinkCell url={value} /> : isBadge ? <Badge status={value} /> : isMarket ? <MarketBadge market={value} /> : value}
      </div>
    </div>
  )
}

function Section({ label, children }) {
  return (
    <div style={{marginBottom:4}}>
      <div style={{fontSize:9,fontWeight:700,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'1px',fontFamily:'DM Mono,monospace',padding:'10px 0 6px',borderBottom:'1px solid var(--border2)'}}>{label}</div>
      {children}
    </div>
  )
}

export function ViewProduct({ row, onClose }) {
  if (!row) return null
  const fmt = v => v == null ? null : `€${Number(v).toFixed(2)}`
  return (
    <Modal title={row.product_name} onClose={onClose}
      footer={<button className="btn btn-ghost" onClick={onClose}>Close</button>}>

      <Section label="Product Info">
        <Row label="Product ID" value={row.product_id} />
        <Row label="Product Name" value={row.product_name} />
      </Section>

      {/* Financial Summary */}
      <div style={{margin:'12px 0',background:'var(--bg3)',border:'1px solid var(--border)',borderRadius:10,padding:14}}>
        <div style={{fontSize:9,fontWeight:700,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'1px',fontFamily:'DM Mono,monospace',marginBottom:12}}>Financial Summary</div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:6}}>
          {[
            ['Sourcing (USD)', `$${row.sourcing_cost_usd}`, null],
            ['Sourcing (€)', fmt(row.sourcing_cost_eur), null],
            ['Shipping (USD)', `$${row.shipping_cost_usd}`, null],
            ['Shipping (€)', fmt(row.shipping_cost_eur), null],
            ['Total COGs', fmt(row.total_cogs), null],
            ['Selling Price', fmt(row.selling_price_eur), null],
            ['Shopify Fee', fmt(row.shopify_fee), null],
            ['Currency Conv', fmt(row.currency_conv), null],
            ['Total Fees', fmt(row.total_fees), null],
            ['Profit Margin', row.profit_margin!=null?row.profit_margin+'%':'—', null],
          ].map(([l, v]) => (
            <div key={l} style={{background:'var(--bg2)',borderRadius:7,padding:'8px 10px',border:'1px solid var(--border)'}}>
              <div style={{fontSize:9,color:'var(--text3)',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.5px',fontFamily:'DM Mono,monospace',marginBottom:3}}>{l}</div>
              <div style={{fontSize:13,fontWeight:600,color:'var(--text)',fontFamily:'DM Mono,monospace'}}>{v || '—'}</div>
            </div>
          ))}
          <div style={{background: row.profit >= 0 ? 'rgba(16,185,129,0.08)' : 'rgba(239,68,68,0.08)', borderRadius:7, padding:'8px 10px', border:`1px solid ${row.profit >= 0 ? 'rgba(16,185,129,0.25)' : 'rgba(239,68,68,0.25)'}`}}>
            <div style={{fontSize:9,color:'var(--text3)',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.5px',fontFamily:'DM Mono,monospace',marginBottom:3}}>Profit (€)</div>
            <div style={{fontSize:15,fontWeight:700,color:row.profit>=0?'var(--accent3)':'var(--red)',fontFamily:'DM Mono,monospace'}}>{fmt(row.profit)}</div>
          </div>
          <div style={{background:'rgba(139,92,246,0.08)',borderRadius:7,padding:'8px 10px',border:'1px solid rgba(139,92,246,0.25)'}}>
            <div style={{fontSize:9,color:'var(--text3)',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.5px',fontFamily:'DM Mono,monospace',marginBottom:3}}>BE ROAS</div>
            <div style={{fontSize:15,fontWeight:700,color:'var(--purple)',fontFamily:'DM Mono,monospace'}}>{row.be_roas ? `${row.be_roas}x` : '—'}</div>
          </div>
        </div>
      </div>

      <Section label="Competitor Info">
        <Row label="Competitor Product URL" value={row.competitor_product_url} isLink />
        <Row label="Advertorial URL" value={row.competitor_advertorial_url} isLink />
        <Row label="Competitor Page Ad URL" value={row.competitor_page_ad_url} isLink />
        <Row label="Competitor Creative Link" value={row.competitor_ad_creative_link} isLink />
        <div style={{display:'flex',gap:12,padding:'9px 0',borderBottom:'1px solid var(--border)',alignItems:'center'}}>
          <div style={{width:170,flexShrink:0,fontSize:10,fontWeight:600,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.7px',fontFamily:'DM Mono,monospace'}}>Comp Advertorial HTML</div>
          <div style={{flex:1}}><HtmlCell has={row.has_adv_html} id={row.id} which="adv" canEdit={false} /></div>
        </div>
        <div style={{display:'flex',gap:12,padding:'9px 0',borderBottom:'1px solid var(--border)',alignItems:'center'}}>
          <div style={{width:170,flexShrink:0,fontSize:10,fontWeight:600,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.7px',fontFamily:'DM Mono,monospace'}}>Comp Sales HTML</div>
          <div style={{flex:1}}><HtmlCell has={row.has_sales_html} id={row.id} which="sales" canEdit={false} /></div>
        </div>
        {row.competitor_winning_ad_links && (
          <div style={{display:'flex',gap:12,padding:'9px 0',borderBottom:'1px solid var(--border)',alignItems:'flex-start'}}>
            <div style={{width:170,flexShrink:0,fontSize:10,fontWeight:600,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.7px',paddingTop:3,fontFamily:'DM Mono,monospace'}}>Winning Ad Links</div>
            <div style={{flex:1,display:'flex',flexDirection:'column',gap:4}}>
              {row.competitor_winning_ad_links.split('\n').map(l=>l.trim().replace(/^"|"$/g,'')).filter(Boolean).map((url,i)=>(
                url.startsWith('http')
                  ? <a key={i} href={url} target="_blank" rel="noopener noreferrer" style={{color:'var(--accent)',fontSize:12,textDecoration:'none'}} onMouseEnter={e=>e.target.style.textDecoration='underline'} onMouseLeave={e=>e.target.style.textDecoration='none'}>🔗 Ad Link {i+1}</a>
                  : <span key={i} style={{fontSize:12,color:'var(--text)'}}>{url}</span>
              ))}
            </div>
          </div>
        )}
        <Row label="Comp Ad Copy — Primary" value={row.competitor_ad_copy_primary} />
        <Row label="Comp Ad Copy — Headline" value={row.competitor_ad_copy_headline} />
      </Section>

      <Section label="Offer & Notes">
        {row.offer_by_market && Object.entries(row.offer_by_market).filter(([,v])=>v&&v.trim()).map(([m,v]) => <Row key={m} label={`Offer — ${m}`} value={v} />)}
        <Row label="Approved By" value={row.approved_by && row.approved_by !== '(pre-existing)' ? row.approved_by : ''} />
        <Row label="Your Recommendations" value={row.research_notes} />
        <Row label="Platform Found On" value={row.platform_found_on} />
        <Row label="Competitor Price" value={row.competitor_price} />
        <Row label="Estimated Margin" value={row.estimated_margin} />
        <Row label="Ad Running Duration" value={row.ad_running_duration} />
        <Row label="Countries Running In" value={row.ad_countries} />
        <Row label="Scale Signal" value={row.scale_signal} />
        <Row label="Ad Hook" value={row.ad_hook} />
        <Row label="Angle Used" value={row.ad_angle} />
        <Row label="Market Saturated?" value={row.market_saturated} />
        <Row label="Desire Targeted" value={row.desire_targeted} />
        <Row label="Customer Concerns" value={row.customer_concerns} />
        <Row label="Problem Addressed" value={row.problem_addressed} />
        <Row label="Target Audience" value={row.target_audience} />
        <Row label="Key Competitor Positioning" value={row.competitor_positioning} />
      </Section>
    </Modal>
  )
}

export function ViewFunnel({ row, onClose }) {
  if (!row) return null
  return (
    <Modal title={`${row.product_name} — ${row.market}`} onClose={onClose}
      footer={<button className="btn btn-ghost" onClick={onClose}>Close</button>}>

      <Section label="Funnel Info">
        <Row label="Market" value={row.market} isMarket />
        <Row label="Product ID" value={row.p_product_id || row.product_id} />
        <Row label="Product Name" value={row.product_name} />
        <Row label="Brand Name" value={row.brand_name} />
        <Row label="Who Creates" value={row.who_creates_funnel} />
        <Row label="Funnel Link" value={row.funnel_link} isLink />
        <Row label="Status" value={row.funnel_status} isBadge />
        <Row label="Date Completed" value={row.date_completed} />
        <Row label="Competitor Link" value={row.competitor_product_url} isLink />
        <Row label="Offer to Use" value={row.offer_to_use} />
      </Section>

      {row.title && (
        <Section label="Generated Content">
          <Row label="Title" value={row.title} />
          {row.benefits && (
            <div style={{padding:'9px 0',borderBottom:'1px solid var(--border)'}}>
              <div style={{fontSize:10,fontWeight:600,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.7px',fontFamily:'DM Mono,monospace',marginBottom:6}}>Benefits</div>
              <div style={{fontSize:13,color:'var(--text)',whiteSpace:'pre-line',lineHeight:1.6}}>{row.benefits}</div>
            </div>
          )}
          {row.paragraphs && (
            <div style={{padding:'9px 0',borderBottom:'1px solid var(--border)'}}>
              <div style={{fontSize:10,fontWeight:600,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.7px',fontFamily:'DM Mono,monospace',marginBottom:6}}>Paragraphs</div>
              <div style={{fontSize:13,color:'var(--text)',whiteSpace:'pre-line',maxHeight:300,overflowY:'auto',lineHeight:1.6}}>{row.paragraphs}</div>
            </div>
          )}
          {row.reviews && (
            <div style={{padding:'9px 0',borderBottom:'1px solid var(--border)'}}>
              <div style={{fontSize:10,fontWeight:600,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.7px',fontFamily:'DM Mono,monospace',marginBottom:6}}>Reviews</div>
              <div style={{fontSize:13,color:'var(--text)',whiteSpace:'pre-line',maxHeight:200,overflowY:'auto',lineHeight:1.6}}>{row.reviews}</div>
            </div>
          )}
          {row.faqs && (
            <div style={{padding:'9px 0',borderBottom:'1px solid var(--border)'}}>
              <div style={{fontSize:10,fontWeight:600,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.7px',fontFamily:'DM Mono,monospace',marginBottom:6}}>FAQs</div>
              <div style={{fontSize:13,color:'var(--text)',whiteSpace:'pre-line',maxHeight:200,overflowY:'auto',lineHeight:1.6}}>{row.faqs}</div>
            </div>
          )}
        </Section>
      )}

      {row.audit_report && (
        <Section label="Audit Report">
          <div style={{fontSize:12,color:'var(--text)',whiteSpace:'pre-wrap',lineHeight:1.7,maxHeight:300,overflowY:'auto',background:'var(--bg3)',borderRadius:8,padding:'10px 12px',marginTop:6,fontFamily:'DM Mono,monospace',fontSize:11}}>{row.audit_report}</div>
        </Section>
      )}
    </Modal>
  )
}

export function ViewCreative({ row, onClose }) {
  if (!row) return null
  return (
    <Modal title={`${row.product_name} — ${row.market}`} onClose={onClose}
      footer={<button className="btn btn-ghost" onClick={onClose}>Close</button>}>
      <Section label="Creative Info">
        <Row label="Market" value={row.market} isMarket />
        <Row label="Product Name" value={row.product_name} />
        <Row label="Brand Name" value={row.brand_name} />
        <Row label="Assigned Editor" value={row.assigned_editor} />
        <Row label="Creative File/Link" value={row.creative_file_link} isLink />
        <Row label="Status" value={row.creative_status} isBadge />
        <Row label="Revision Notes" value={row.revision_notes} />
      </Section>
      <Section label="Competitor Info">
        <Row label="Competitor Link" value={row.competitor_product_url} isLink />
        {row.competitor_winning_ad_links && (
          <div style={{display:'flex',gap:12,padding:'9px 0',borderBottom:'1px solid var(--border)',alignItems:'flex-start'}}>
            <div style={{width:170,flexShrink:0,fontSize:10,fontWeight:600,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'0.7px',paddingTop:3,fontFamily:'DM Mono,monospace'}}>Winning Ad Links</div>
            <div style={{flex:1,display:'flex',flexDirection:'column',gap:4}}>
              {row.competitor_winning_ad_links.split('\n').map(l=>l.trim().replace(/^"|"$/g,'')).filter(Boolean).map((url,i)=>(
                url.startsWith('http')
                  ? <a key={i} href={url} target="_blank" rel="noopener noreferrer" style={{color:'var(--accent)',fontSize:12,textDecoration:'none'}} onMouseEnter={e=>e.target.style.textDecoration='underline'} onMouseLeave={e=>e.target.style.textDecoration='none'}>🔗 Ad {i+1}</a>
                  : <span key={i} style={{fontSize:12,color:'var(--text)'}}>{url}</span>
              ))}
            </div>
          </div>
        )}
      </Section>
    </Modal>
  )
}

export function ViewAdCopy({ row, onClose }) {
  if (!row) return null
  return (
    <Modal title={`${row.product_name} — ${row.market}`} onClose={onClose}
      footer={<button className="btn btn-ghost" onClick={onClose}>Close</button>}>
      <Section label="Ad Copy Info">
        <Row label="Market" value={row.market} isMarket />
        <Row label="Product Name" value={row.product_name} />
        <Row label="Brand Name" value={row.brand_name} />
        <Row label="Funnel Link" value={row.funnel_link} isLink />
        <Row label="Status" value={row.status} isBadge />
        <Row label="Approved By" value={row.approved_by} />
      </Section>
      <Section label="Competitor Copy">
        <Row label="Competitor Primary" value={row.competitor_ad_copy_primary} />
        <Row label="Competitor Headline" value={row.competitor_ad_copy_headline} />
      </Section>
      <Section label="AI Generated Copy">
        <Row label="AI Primary Text" value={row.ai_copy_primary} />
        <Row label="AI Headline" value={row.ai_copy_headline} />
      </Section>
      {(row.adapted_copy_primary || row.adapted_copy_headline) && (
        <Section label="✨ Adapted Copy">
          <Row label="Adapted Primary" value={row.adapted_copy_primary} />
          <Row label="Adapted Headline" value={row.adapted_copy_headline} />
        </Section>
      )}
    </Modal>
  )
}

export function ViewScheduling({ row, onClose }) {
  if (!row) return null
  return (
    <Modal title={`${row.product_name} — ${row.market}`} onClose={onClose}
      footer={<button className="btn btn-ghost" onClick={onClose}>Close</button>}>
      <Section label="Campaign Info">
        <Row label="Market" value={row.market} isMarket />
        <Row label="Product Name" value={row.product_name} />
        <Row label="Brand Name" value={row.brand_name} />
        <Row label="Ad Account" value={row.ad_account} />
        <Row label="Campaign Name" value={row.campaign_name} />
        <Row label="Daily Budget (€)" value={row.daily_budget_eur} />
        <Row label="Scheduled Date" value={row.scheduled_date} />
        <Row label="Campaign Status" value={row.campaign_status} isBadge />
        <Row label="Creative File/Link" value={row.creative_file_link} isLink />
        <Row label="Funnel Link" value={row.funnel_link} isLink />
      </Section>
      <Section label="Ad Copy">
        <Row label="AI Primary" value={row.ai_copy_primary} />
        <Row label="AI Headline" value={row.ai_copy_headline} />
        {(row.adapted_copy_primary || row.adapted_copy_headline) && (
          <>
            <Row label="Adapted Primary" value={row.adapted_copy_primary} />
            <Row label="Adapted Headline" value={row.adapted_copy_headline} />
          </>
        )}
      </Section>
    </Modal>
  )
}

export function ViewWinning({ row, onClose }) {
  if (!row) return null
  const fmt = v => v == null ? null : `€${Number(v).toFixed(2)}`
  return (
    <Modal title={`${row.product_name} — ${row.market}`} onClose={onClose}
      footer={<button className="btn btn-ghost" onClick={onClose}>Close</button>}>
      <Section label="Winning Product Info">
        <Row label="Market" value={row.market} isMarket />
        <Row label="Product Name" value={row.product_name} />
        <Row label="Brand Name" value={row.brand_name} />
        <Row label="BE ROAS" value={row.be_roas ? `${row.be_roas}x` : null} />
        <Row label="Profit" value={fmt(row.profit)} />
        <Row label="Ad Account" value={row.ad_account} />
        <Row label="Campaign Name" value={row.campaign_name} />
        <Row label="Funnel Link" value={row.funnel_link} isLink />
        <Row label="Creative File/Link" value={row.creative_file_link} isLink />
        <Row label="Date Added as Winner" value={row.date_added_as_winner} />
        <Row label="Last Creative Date" value={row.last_creative_added_date} />
        <Row label="Comments" value={row.comments} />
      </Section>
    </Modal>
  )
}
